import {Component, inject, Input, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {ResponseAvis} from "../../../common/services/avis/response-avis.model";
import {MatDataSourceGeneric} from "@Services/base/daoService";
import {ActionDataTable, ColumnDataTable, DataTableComponent} from "@Common/widgets/general/data-table";
import {DatePipe} from "@angular/common";
import {ResponseAvisHistoric} from "../../../common/services/avis/response-avis-historic.model";
import {ResponseAvisHistoricService} from "../../../common/services/avis/response-avis-historic.service";
import {NewlinePipe, SafeHtmlPipe} from "@Common/widgets/pipes";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-historic-list',
  templateUrl: './historic-list.component.html',
  styleUrls: ['./historic-list.component.scss']
})
export class HistoricListComponent implements OnInit {
  @Input() avis: ResponseAvis;

  dsHistoricAvis: MatDataSourceGeneric<ResponseAvisHistoric> = new MatDataSourceGeneric<ResponseAvisHistoric>();
  extraParams: Map<string, string> = new Map<string, string>();

  historicAvisSvc = inject(ResponseAvisHistoricService);
  locale = inject(LOCALE_ID);

  columns: ColumnDataTable[] = [
    { columnDef: 'dt_created', header: 'Date', display: (avis: ResponseAvisHistoric) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return `<strong>${dp.transform(`${avis.dt_created}`, 'dd/MM/yyyy H:mm')}</strong>`;
      },
      sort: false,
      flex: 20
    },

    { columnDef: 'connected', header: 'Qui', display: (avis: ResponseAvisHistoric) => {
        if (avis.connected) {
          return `${avis.connected_obj.first_name} ${avis.connected_obj.last_name}`;
        }
        return 'n/a';
      },
      sort: false,
      tooltip: (avis: ResponseAvisHistoric) => {
        if (avis.connected_obj && avis.connected_obj.phone_pro) {
          return `${avis.connected_obj.email_pro} - ${avis.connected_obj.phone_pro}`;
        }

        return '';
      },
      flex: 10
    },

    { columnDef: 'avis', header: 'Avis',
      display: (avis: ResponseAvisHistoric) => this._getLabelAvis(avis),
      sort: false,
    },
    { columnDef: 'motivation', header: 'Motivation',
      display: (avis: ResponseAvisHistoric) => avis.motivation,
      tooltip: (avis: ResponseAvisHistoric) => `${avis.motivation}`,
      truncate: true,
      sort: false,
    },
  ];
  actions: ActionDataTable[] = [];
  @ViewChild(DataTableComponent, { static: true }) dataTable: DataTableComponent;
  sanitizer = inject(DomSanitizer);
  constructor() {
    this.dsHistoricAvis.daoService = this.historicAvisSvc;
  }
  ngOnInit() {
    if (this.avis) {
      this.extraParams.set('expert_individu', this.avis.expert_individu);
      this.extraParams.set('response', this.avis.response.toString());
    }
  }
  public textMessageSent() {
    if (this.avis?.message_question) {
      const nl: NewlinePipe = new NewlinePipe();
      const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitizer);
      return sp.transform(`<p>${nl.transform(this.avis.message_question)}</p>`);
    }
    return '-'
  }
  public titlePath() {
    const _titlePath = ['Avis', 'Historique'];
    if (this.avis) {
      let _infos = this.avis?.response_obj?.reference || '';
      const _sollicite = `${this.avis?.expert_individu_obj?.first_name} ${this.avis?.expert_individu_obj?.last_name}`
      return [..._titlePath, _sollicite, _infos];
    }
    return _titlePath;
  }
  private _getLabelAvis(avis: ResponseAvisHistoric) {
    return this.historicAvisSvc.getChipAvis(avis);
  }

}
